var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 32,
    viewBox: "0 0 18 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.96 29.936l14.952-6.096L.96 17.768v-1.752L18 23.072v1.536L.96 31.688v-1.752z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.575H.984v-1.68h9.888L.96 2.51V.663l7.488 6.96L18 .303v1.896L9.456 8.703l3.312 3.192H18v1.68z",
    fill: "#fff"
  })));
};

export default SvgVk;